import React from 'react';
import { Copy, Label } from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { SSOIdentifierEnum } from 'src/types/Corp';
import { CookbookRadioWrapper } from 'src/components/CookbookRadioWrapper/CookbookRadioWrapper';

export interface SSOIdentifierProps {
  name: string;
  id: string;
}

export function SSOIdentifier({ name, id }: SSOIdentifierProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <>
      <Label aria-label="SSOIdentifier" inputSize="medium">
        <Copy variant="body" strong>
          Select the SSO identifier *
        </Copy>
      </Label>
      <CookbookRadioWrapper
        name={name}
        id={`${id}${SSOIdentifierEnum.EMAIL}`}
        control={control}
        label="Email"
        value={SSOIdentifierEnum.EMAIL}
      />
      <CookbookRadioWrapper
        name={name}
        id={`${id}${SSOIdentifierEnum.INTERNALID}`}
        control={control}
        label="Internal ID"
        value={SSOIdentifierEnum.INTERNALID}
      />
      <CookbookRadioWrapper
        name={name}
        id={`${id}${SSOIdentifierEnum.OTHER}`}
        control={control}
        label="Other"
        value={SSOIdentifierEnum.OTHER}
      />
    </>
  );
}
